var $d188eca5a5ae523e$exports = {};
$d188eca5a5ae523e$exports = {
    "pending": `\u{642}\u{64A}\u{62F} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{638}\u{627}\u{631}`
};


export {$d188eca5a5ae523e$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
